<template>
    <div>
        <div class="titleConfirm">{{title}}</div>
        
        <div class="msgConfirm">{{msg}}</div>

        <div class="d-flex flex-row-reverse buttonsConfirm">
            <b-button @click="clickNo" variant="outline-danger">{{$t('no')}}</b-button>
            <b-button @click="clickYes" variant="outline-success">{{$t('yes')}}</b-button>
        </div> 
    </div>
</template>

<script>
export default {
    props: {
        title:String,
        msg:String
    },
    methods:{
        clickYes(){
            this.$emit('eventDialogAddUpdateKeywordsAlertsConfirmation', true )
        },
        clickNo(){
            this.$emit('eventDialogAddUpdateKeywordsAlertsConfirmation', false )
        }
    }
}
</script>

<style>

    .buttonsConfirm > button{
	    margin:5px;
    }

    .titleConfirm{
	    margin-bottom: 30px;
        padding-bottom: 10px;
        font-size: 18px;
        border-bottom: 1px solid #ccc;
    }

    .msgConfirm{
        margin:10px;
    }


</style>